import { ChangeDetectionStrategy, Component } from '@angular/core';

import { environment } from '@fb/environments';

@Component({
  standalone: true,
  selector: 'pu-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  isPt = environment.shortName === 'pt';
}
